import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageSizeUrl } from '../../lib/utils';

import styles from '../../../styles/partials/partners.module.scss';

const propTypes = {
    partners: AppPropTypes.partners,
    className: PropTypes.string,
    isDark: PropTypes.bool,
    withPartners: PropTypes.bool,
};

const defaultProps = {
    partners: null,
    className: null,
    isDark: false,
    withPartners: true,
};

const Partners = ({ partners, className, isDark, withPartners }) => (
    <div
        className={classNames([
            styles.container,
            {
                [styles.isDark]: isDark,
                [className]: className !== null,
            },
        ])}
    >
        {withPartners && partners !== null && partners.length > 0 ? (
            <div className={styles.partners}>
                {partners.map(({ name, url, image }, idx) => {
                    const imageUrl = getImageSizeUrl(image, 'small');
                    return (
                        <div className={styles.partner} key={`${name}-${idx + 1}`}>
                            <a href={url} className={styles.link} target="_blank" rel="noreferrer">
                                <div className={styles.name}>{name}</div>
                                {imageUrl !== null ? (
                                    <div className={styles.imageContainer}>
                                        <img src={imageUrl} alt={name} className={styles.image} />
                                    </div>
                                ) : null}
                            </a>
                        </div>
                    );
                })}
            </div>
        ) : null}
    </div>
);
Partners.propTypes = propTypes;
Partners.defaultProps = defaultProps;

export default Partners;
